import React, { useState } from 'react';
import MatTabs from '../common/matTabs';

import CollegeRecognisationPage from './recognisation/collegeRecognisation.page';
import CollegeOtherRecognisationPage from './other-recognisations/collegeOtherRecognisation.page';
import CollegeInfrastructurePage from './infrastructure/collegeInfrastructure.page';
import CollegeBasicInfoPage from './basic-info/collegeBasicInfo.page';
import CollegeStatusPage from './status/collegeStatus.page';
import { Box } from '@mui/material';
const CollegeInfo = ({ id }) => {

    const [selected, setSelected] = useState(0)
    // const [id,setId]=useState(authService.getInstituteTenant())
    function handleChange(event, value) {
        // console.log("selected:", value);
        // console.log("selected:", event);


        setSelected(value)
    }

    const list = [
        { label: "Basic Info" },
        { label: "Status" },
        { label: "Recognitions" },
        { label: "Other Recognitions" },
        { label: "Infrastructure" }
    ]

    function getTab(selected) {
        switch (selected) {
            case 0:
                return <CollegeBasicInfoPage id={id} />;
            case 1:
                return <CollegeStatusPage id={id} />;
            case 2:
                return <CollegeRecognisationPage id={id} />;
            case 3:
                return <CollegeOtherRecognisationPage id={id} />;
            case 4:
                return <CollegeInfrastructurePage id={id} />;

        }
    }

    return (<>

        <MatTabs tabs={list} onChange={handleChange} value={selected} />
        {/* <Box > */}
            <br />
            {getTab(selected)}
        {/* </Box> */}

    </>);
}

export default CollegeInfo;